export default "__VITE_ASSET__BTsUX29t__"